const IMG = {
    logoLight: '/img/logo-FutaFunong-bgwhite.png',
    logoDark: '/img/logo-FutaFunong.png',
    futaExpress: '/img/futa-express.png',
    futaBusLines: '/img/futa-bus-lines.png',
    bgLogin: '/img/bg-login.png',
    bgLoginMb: '/img/bg-login-mb.png',
    loginInfoGraphic: '/img/login-info-graphic.png',
    success: '/img/success.png',
    imageUpload: '/img/image-upload.svg',
    emptyProduct: '/img/empty-product.png',
    userCircle: '/img/user-circle.svg',
    popupUpdateStatus: '/img/popup-update-status.svg',
    createProductSuccess: '/img/create-product-success.svg',
    defaultProduct: '/img/def_product.png',
    popupSuccess: '/img/popup-success.svg',
    goopayLogo: '/img/goopay-logo.png',
    od: '/img/0d.png',
    van: '/img/van.png',
    futaExpressTransparent: '/img/futa-express.svg',
    userGroup: '/img/user-group.png',
    ios: '/img/ios.png',
    android: '/img/android.png',
    logoFuNong: '/img/logo-funong.png',
    default: '/img/image-default.png',
    testProduct: '/img/test.svg',
    avatarDefault: '/img/avatar-default-shop.jpg',
    avatarDefaultUser: '/img/avatar-default-user.png',
    icon: {
        building: '/img/icon/building.png',
        infoTooltip: '/img/icon/info-tooltip.svg',
        arrowTriangleRight: '/img/icon/arrow-triangle-right.svg',
        exclamation: '/img/icon/exclamation.svg',
        errorOutline: '/img/icon/error_outline.svg',
        phoneLight: '/img/icon/phone-light.png',
        locationLight: '/img/icon/location-light.png',
        newsLight: '/img/icon/news-light.png',
        vanLight: '/img/icon/van-light.svg',
        phoneIpBlack: '/img/icon/phone-ip-black.svg',
        lockedBlack: '/img/icon/locked-black.svg',
        phone: '/img/icon/phone.svg',
        edit: '/img/icon/edit.svg',
        trash: '/img/icon/trash.png',
        eyeBlack: '/img/icon/eye-black.png',
        eyeGray: '/img/icon/eye-gray.svg',
        eyeBlackOpen: '/img/icon/eye-black-open.svg',
        exclamationRed: '/img/icon/exclamation.png',
        eyeOpenLight: '/img/icon/eye-open-light.svg',
        eyeOffLight: '/img/icon/eye-off-light.svg',
        boxBlack: '/img/icon/box-black.png',
        setup: '/img/icon/setup.svg',
        setupColor: '/img/icon/setup-color.svg',
        shareGreen: '/img/icon/share-green.svg',
        copy: '/img/icon/copy.svg',
        download: '/img/icon/download.svg',
        chevronLeftBlack: '/img/icon/chevron-left-black.svg',
        chevronRightBlack: '/img/icon/chevron-right-black.svg',
        chevronLefLight: '/img/icon/chevron-left-light.svg',
        setupGreen: '/img/icon/setup-green.svg',
        newspaper: '/img/icon/newspaper.svg',
        logout: '/img/icon/logout.svg',
        boxGreen: '/img/icon/box-green.svg',
        boxBorderGreen: '/img/icon/cube-border-green.svg',
        storeBlack: '/img/icon/store-black.svg',
        storeGreen: '/img/icon/store-green.svg',
        userBlack: '/img/icon/account-black.png',
        userGreen: '/img/icon/account-green.svg',
        userGreenOutline: '/img/icon/user-green-outline.svg',
        arrowDown: '/img/icon/arrow-down.svg',
        cameraCircle: '/img/icon/camera-circle.svg',
        share: '/img/icon/share.svg',
        pencil: '/img/icon/pencil.svg',
        pencilLight: '/img/icon/pencil-light.svg',
        documentCheck: '/img/icon/document-check.svg',
        clipboardList: '/img/icon/clipboard-list.png',
        clipboardListActive: '/img/icon/clipboard-list-active.svg',
        chevronRight: '/img/icon/chevron-right.svg',
        userCircle: '/img/icon/user-circle.svg',
        chevronRightLight: '/img/icon/chevron-right-light.svg',
        video: '/img/icon/video-ico.svg',
        arrowUp: '/img/icon/arrow-up.svg',
        search: '/img/icon/search.svg',
        location: '/img/icon/location.svg',
        locationActive: '/img/icon/location-green.svg',
        close: '/img/icon/close.svg',
        truck: '/img/icon/truck.png',
        truckBlack: '/img/icon/truck-black.svg',
        truckGreen: '/img/icon/truck-green.svg',
        ban: '/img/icon/ban.png',
        check: '/img/icon/check.png',
        userGroup: '/img/icon/user-group.png',
        orderCancel: '/img/icon/order-cancel.svg',
        orderPending: '/img/icon/order-pending.svg',
        orderDelivering: '/img/icon/order-delivering.svg',
        orderReturned: '/img/icon/order-returned.svg',
        shipping: '/img/icon/order-returned.svg',
        orderSuccess: '/img/icon/order-success.svg',
        errorOutlineBlack: '/img/icon/error_outline_black.svg',
        errorOutlineGray: '/img/icon/error_outline-gray.svg',
        cart: '/img/icon/cart.png',
        chevronDoubleDown: '/img/icon/chevron-double-down.svg',
        chevronRightPagination: '/img/icon/chevron-right-pagination.svg',
        chevronDown: '/img/icon/chevron-down.svg',
        iconSuccess: '/img/icon/icon-success.png',
        documentCancel: '/img/icon/document-cancel.svg',
        document: '/img/icon/document.svg',
        locationMarker: '/img/icon/location-marker.svg',
        cube: '/img/icon/cube.svg',
        cubeGreen: '/img/icon/cube-green.svg',
        notification: '/img/icon/notification.svg',
        home: '/img/icon/home.svg',
        documentCheckYellow: '/img/icon/document-check-yellow.svg',
        warningRed: '/img/icon/warning-red.svg',
        shieldCheck: '/img/icon/shield-check.svg',
        calendar: '/img/icon/calendar.svg',
        homeSeller: '/img/icon/home-seller.svg',
        homeSellerActive: '/img/icon/home-seller-active.svg',
        car: '/img/icon/car.svg',
        empty: '/img/icon/empty.svg',
        lockClosed: '/img/icon/lock-closed.svg',
    },
    gif: {
        loading: '/gif/loading.gif'
    },
    background: {
        abstract: '/img/background/abstract.png'
    },
    logo: {
        futae: '/img/logo/logo-futae.svg',
        selfDelivery: '/img/logo/self-delivery.svg',
        selfDeliverySeller: '/img/logo/self-delivery-seller.svg',
    }
}

export default IMG
